<template>
  <div id="c_container">
    <div class="relative ml-4 w-5/6 md:w-1/3 top-3/10 ab_container one draggable" :class="{ desktop_a : !isMobile }">
      <p class="t">{{ about.content_header }}</p>
      <vue-markdown class="pp">{{ about.content }}</vue-markdown>
    </div>

    <div v-if="about.display_clients" class="relative ml-4 w-5/6 mt-8 md:w-1/3 top-2/3 ab_container two draggable" :class="{ desktop_b : !isMobile }">
      <p class="t">{{ about.clients_header }}</p>
      <vue-markdown class="pp">{{ about.clients }}</vue-markdown>
    </div>

    <div class="relative ml-4 w-5/6 mt-8 md:bottom-4 credits draggable" :class="{ desktop_credits : !isMobile }">
      <div class="pp"><a href="http://www.mariannenoordzij.nl" target="_blank">?</a></div>
    </div>
  </div>
</template>

<script>
import interact from "interactjs";

export default {
  name: "About",
  props: ['about', 'isMobile'],
  mounted() {
    this.enableDragDrop();
  },
  methods: {
    enableDragDrop() {
      const htmlList = document.getElementsByClassName('draggable'); 
      for (let htmlItem of htmlList) {
      let x = 0;
      let y = 0;
      console.log(htmlItem)
        interact(htmlItem)
          .draggable({
            ignoreFrom: '.list',
            modifiers: [
              interact.modifiers.snap({
                targets: [interact.createSnapGrid({ x: 25, y: 25 })],
                range: Infinity,
                relativePoints: [{ x: 0, y: 0 }]
              }),
              interact.modifiers.restrict({
                restriction: document.getElementById('body'),
                elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
              })
            ],
            inertia: true
          })
          .on("dragmove", function(event) {
            x += event.dx;
            y += event.dy;
            event.target.style.webkitTransform = event.target.style.transform =
              "translate(" + x + "px, " + y + "px)";
          });
      }
    }
  }
}
</script>

<style>
.ab_container, .credits{
  background-color:rgb(238, 238, 238);
  border: 1px solid black;
  background-image: url('../assets/drag.svg');
  background-position-y: top;
  background-size: 15px;
  background-position-x: left;
  background-repeat: no-repeat;
  padding:0px 15px 0 15px;
  z-index:75;
  text-align:left;
  pointer-events:all;
  touch-action: none;
}

.credits {
  width:50px;
  padding-top:5px;
  padding-bottom:5px;
}

#c_container {
  top:8vh;
  position:absolute;
  width:100%;
  height:calc(100% - 8vh);
}

.desktop_credits {
  position:absolute;
  bottom:5vh;
  right:10vw;
  font-size:18px;
  padding:10px 15px 10px 15px;
  margin-block-start: 8px;
  margin-block-end: 14px;
}

.desktop_a {
  top:5vh;
  left:8vw;
}

.desktop_a p, .desktop_a t, .desktop_a a, .desktop_credits a {
  font-size:18px;
}

.desktop_b {
  top:5vh;
  left:55vw;
}

.desktop_b p, .desktop_b t, .desktop_b em, .desktop_b a{
  font-size:18px;
}


.pp * {
  text-align:left;
  font-size:16px;
  margin-block-start: 8px;
  margin-block-end: 14px;
}

.t {
  font-family: L;
  font-size:16px;
  text-transform: uppercase;
  margin-top:14px;
}

</style>


